<script setup lang="ts"></script>
<template>
  <div class="d-flex flex-column fill-viewport">
    <slot name="site-header" />
    <div class="position-relative flex-fill d-flex slot-layout">
      <div class="container-fluid p-0">
        <slot />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
$mobile-header-height: 78px;
.slot-layout {
  margin-top: 3rem;
  @media screen and (max-width: 991px) {
    margin-top: 1rem;
  }
}
</style>
